const customMediaQuery = (minWidth: string) =>
  `@media (min-width: ${minWidth})`;

export const breakpoints = [
  '320px',
  '375px',
  '425px',
  '768px',
  '1024px',
  '1440px',
  '2560px',
];

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`,
};

const Media = {
  custom: customMediaQuery,
  mobileS: customMediaQuery(breakpoints[0]),
  mobileM: customMediaQuery(breakpoints[1]),
  mobileL: customMediaQuery(breakpoints[2]),
  tablet: customMediaQuery(breakpoints[3]),
  laptop: customMediaQuery(breakpoints[4]),
  laptopL: customMediaQuery(breakpoints[5]),
  desktop: customMediaQuery(breakpoints[6]),
};

export default Media;
